import { SimpleLinkRenderer } from "widgets/commonComponents/inline/hyperLink"
import { YnetPremiumLoginDesktop } from "../ynetPremiumLogin/ynetPremiumLoginDesktop"
import { YnetPianoLogin, YnetPlusUserMenuItems } from "../../../../../ynetSearch/components/ynetPianoLogin/ynetPianoLogin"
require("./yplus_site_premiumHeader.less")

interface PremiumHeaderProps {
    className?: string
    id?: string
    isArticlePage: boolean
    siteId?: string
    isStyckyBar?: boolean
    mainLogoLink: string
    parentSiteLink: string
    ynetPlusMenuItems?: YnetPlusUserMenuItems[]
}

export class PremiumHeader extends React.Component<PremiumHeaderProps, any>{
    static defaultProps = { className: "", isStyckyBar: false }

    render() {
        const { mainLogoLink, parentSiteLink, ynetPlusMenuItems } = this.props
        const className = `PremiumHeader ${this.props.className}`
        let logoImageUrl;
        const isPianoLogin = typeof window != "undefined" && window.YitPaywall && window.YitPaywall.isPianoLogin;

        if (this.props.isArticlePage) {
            logoImageUrl = this.props.siteId === "pplus" ? "/Common/images/pplus-logo.png" : "/Common/images/y-logo.png"
        }
        else {
            logoImageUrl = "/Common/images/y-logo.png"
        }

        return (
            <div className={className} id={this.props.id}>
                <SimpleLinkRenderer className="rightLogo" href={parentSiteLink} >
                    <img src={logoImageUrl} />
                    <span>    ראשי</span>
                </SimpleLinkRenderer>

                {this.props.isStyckyBar ?
                    <div className="rightSideHeader">
                        <SimpleLinkRenderer className="yedioth-plus-logo" href={mainLogoLink} />
                        {this.props.children}
                    </div>
                    :
                    <SimpleLinkRenderer className="yedioth-plus-logo" href={mainLogoLink} />
                }

                <div className="menuWrapper">
            <YnetPianoLogin isPremiumHeaderArticle={true} ynetPlusMenuItems={ynetPlusMenuItems} isPianoLogin={isPianoLogin}/> 
                </div>
            </div>
        )
    }
}